import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useModularPDPPhotos from 'data-hooks/useModularPDPPhotos';
import usePDPViewGalleryImageEvent from 'data-hooks/useEvents/usePDPViewGalleryImageEvent';
import usePDPCylindoViewer from 'data-hooks/usePDPCylindoViewer';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import { getMainImageImgixPropsForPhoto, getThumbnailImageImgixPropsForPhoto } from './helpers/imgix-props';
import Prefetcher from '../../../essentials/Prefetcher';
import PDPDesktopHeroGalleryUI from './PDPDesktopHeroGalleryUI';
import usePDPDesktopHeroSizeProps from './helpers/usePDPDesktopHeroSizeProps';
const getPrefetcherConfig = (lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps) => {
  if (!selectedPhoto || !lastHoveredConfigPhotos.length) {
    return {};
  }
  const mainPhoto = lastHoveredConfigPhotos[selectedPhoto.type === 'studio' || !lastHoveredConfigPhotos[selectedPhoto.index] ? 0 : selectedPhoto.index];
  if (!mainPhoto.src) {
    return {};
  }
  const onRenderAssets = [...lastHoveredConfigPhotos.slice(0, 5).map(({
    src,
    type
  }) => ({
    url: src,
    imgixProps: getThumbnailImageImgixPropsForPhoto({
      src,
      type
    })
  })), {
    url: mainPhoto.src,
    imgixProps: {
      ...getMainImageImgixPropsForPhoto(mainPhoto, enableCrops),
      ...mainPhotoSizeProps
    },
    isProductImage: true
  }];
  return {
    onRenderAssets
  };
};
const PDPDesktopHeroGallery = t0 => {
  const $ = _c(70);
  const {
    isEditOrder: t1,
    mainPhotoLink,
    mode: t2,
    pdpIsModularBYOProduct,
    slug,
    productHeroImage: t3
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productHeroImage = t3 === undefined ? null : t3;
  const {
    loading,
    error,
    data,
    actions
  } = usePDPPhotos(null, slug);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let modularPhotosData = useModularPDPPhotos(null, slug);
  if (!pdpIsModularBYOProduct) {
    modularPhotosData = null;
  }
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  const {
    viewGalleryImageEvent
  } = usePDPViewGalleryImageEvent();
  const t4 = mode === "pdp";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      isPDPDesktop: true,
      deferCylindoFetch: t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    cylindoFeatures,
    isCylindoAvailable,
    cylindoConfigurationPhotos,
    isCylindoConfigurationPhotos,
    dimensionShotUrls,
    currentDimensionShot,
    selectedDimensionShotIndex,
    hasMultipleDimensionShots,
    shouldShowDimensionThumbnail,
    goToNextDimensionShot,
    goToPreviousDimensionShot
  } = usePDPCylindoViewer(t5);
  let t6;
  if ($[2] !== data || $[3] !== modularPhotosData?.data || $[4] !== pdpIsModularBYOProduct) {
    t6 = pdpIsModularBYOProduct ? modularPhotosData?.data ?? {} : data;
    $[2] = data;
    $[3] = modularPhotosData?.data;
    $[4] = pdpIsModularBYOProduct;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const {
    campaign,
    configurationPhotos: nonCylindoConfigurationPhotos,
    dimensionalImage,
    enableCrops,
    introVideoIds,
    isConfigFlipped,
    isVideoSelected,
    lastHoveredConfigPhotos,
    productName,
    selectedPhoto,
    studioPhotos: allStudioPhotos
  } = t6;
  const configurationPhotos = useRemoveBrokenImageUrls(isCylindoConfigurationPhotos ? cylindoConfigurationPhotos : nonCylindoConfigurationPhotos);
  const studioPhotos = useRemoveBrokenImageUrls(allStudioPhotos);
  let t7;
  if ($[6] !== actions || $[7] !== modularPhotosData?.actions || $[8] !== pdpIsModularBYOProduct) {
    t7 = pdpIsModularBYOProduct ? modularPhotosData?.actions ?? {} : actions;
    $[6] = actions;
    $[7] = modularPhotosData?.actions;
    $[8] = pdpIsModularBYOProduct;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const {
    setSelectedPhoto,
    setIsVideoSelected
  } = t7;
  let t8;
  bb0: {
    if (selectedPhoto?.type === "dimensional") {
      if (currentDimensionShot) {
        let t9;
        if ($[10] !== currentDimensionShot.dimensionCode || $[11] !== currentDimensionShot.src || $[12] !== selectedPhoto) {
          t9 = {
            ...selectedPhoto,
            src: currentDimensionShot.src,
            dimensionCode: currentDimensionShot.dimensionCode
          };
          $[10] = currentDimensionShot.dimensionCode;
          $[11] = currentDimensionShot.src;
          $[12] = selectedPhoto;
          $[13] = t9;
        } else {
          t9 = $[13];
        }
        t8 = t9;
        break bb0;
      }
      if (dimensionalImage?.src) {
        let t9;
        if ($[14] !== dimensionalImage.src || $[15] !== selectedPhoto) {
          t9 = {
            ...selectedPhoto,
            src: dimensionalImage.src
          };
          $[14] = dimensionalImage.src;
          $[15] = selectedPhoto;
          $[16] = t9;
        } else {
          t9 = $[16];
        }
        t8 = t9;
        break bb0;
      }
      t8 = selectedPhoto;
      break bb0;
    }
    if (isCylindoConfigurationPhotos && selectedPhoto?.type === "cylindo") {
      t8 = selectedPhoto;
      break bb0;
    }
    if (isCylindoAvailable && !selectedPhoto) {
      if (isCylindoConfigurationPhotos) {
        t8 = cylindoConfigurationPhotos[0];
        break bb0;
      }
      let t9;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
          type: "cylindo"
        };
        $[17] = t9;
      } else {
        t9 = $[17];
      }
      t8 = t9;
      break bb0;
    }
    const resolved = selectedPhoto || studioPhotos[0];
    if (resolved?.src || resolved?.type === "dimensional" || resolved?.type === "cylindo") {
      t8 = resolved;
      break bb0;
    }
    if (productHeroImage?.src) {
      let t9;
      if ($[18] !== productHeroImage.src) {
        t9 = {
          type: "studio",
          id: productHeroImage.src,
          src: productHeroImage.src
        };
        $[18] = productHeroImage.src;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      t8 = t9;
      break bb0;
    }
    t8 = resolved;
  }
  const selectedPhotoToShow = t8;
  let t9;
  if ($[20] !== currentDimensionShot || $[21] !== dimensionalImage || $[22] !== selectedPhoto?.type) {
    t9 = () => {
      if (currentDimensionShot) {
        return currentDimensionShot;
      }
      if (selectedPhoto?.type === "dimensional" && dimensionalImage?.src) {
        return {
          src: dimensionalImage.src,
          dimensionCode: "static",
          id: "static-dimensional"
        };
      }
      return {
        src: "",
        dimensionCode: "none",
        id: "no-dimensional-shot"
      };
    };
    $[20] = currentDimensionShot;
    $[21] = dimensionalImage;
    $[22] = selectedPhoto?.type;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  selectedPhoto?.type;
  let t10;
  if ($[24] !== t9) {
    t10 = t9();
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const currentDimensionShotToShow = t10;
  if (loading && !productHeroImage?.src) {
    const t11 = pdpSelectedCustomizerTab === "decide-later";
    let t12;
    if ($[26] !== mode || $[27] !== t11) {
      t12 = <PDPDesktopHeroGalleryUI loading={true} mode={mode} showDecideLaterOverlay={t11} />;
      $[26] = mode;
      $[27] = t11;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    return t12;
  }
  if (!data) {
    return null;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t11;
  if ($[29] !== enableCrops || $[30] !== lastHoveredConfigPhotos || $[31] !== mainPhotoSizeProps || $[32] !== selectedPhoto) {
    t11 = getPrefetcherConfig(lastHoveredConfigPhotos, selectedPhoto, enableCrops, mainPhotoSizeProps);
    $[29] = enableCrops;
    $[30] = lastHoveredConfigPhotos;
    $[31] = mainPhotoSizeProps;
    $[32] = selectedPhoto;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = pdpSelectedCustomizerTab === "decide-later";
  let t13;
  if ($[34] !== cylindoConfigurationPhotos || $[35] !== setSelectedPhoto) {
    t13 = t14 => {
      const {
        id,
        index,
        src,
        type
      } = t14;
      setSelectedPhoto?.(type === "cylindo" ? cylindoConfigurationPhotos[index] : {
        id,
        index,
        src,
        type
      });
    };
    $[34] = cylindoConfigurationPhotos;
    $[35] = setSelectedPhoto;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const t14 = !isCylindoAvailable;
  let t15;
  if ($[37] !== campaign || $[38] !== configurationPhotos || $[39] !== currentDimensionShotToShow || $[40] !== cylindoFeatures || $[41] !== dimensionShotUrls || $[42] !== dimensionalImage || $[43] !== enableCrops || $[44] !== goToNextDimensionShot || $[45] !== goToPreviousDimensionShot || $[46] !== hasMultipleDimensionShots || $[47] !== introVideoIds || $[48] !== isConfigFlipped || $[49] !== isCylindoAvailable || $[50] !== isCylindoConfigurationPhotos || $[51] !== isEditOrder || $[52] !== isVideoSelected || $[53] !== mainPhotoLink || $[54] !== mode || $[55] !== pdpIsModularBYOProduct || $[56] !== productName || $[57] !== selectedDimensionShotIndex || $[58] !== selectedPhotoToShow || $[59] !== setIsVideoSelected || $[60] !== shouldShowDimensionThumbnail || $[61] !== studioPhotos || $[62] !== t12 || $[63] !== t13 || $[64] !== t14 || $[65] !== viewGalleryImageEvent) {
    t15 = <PDPDesktopHeroGalleryUI configurationPhotos={configurationPhotos} selectedPhoto={selectedPhotoToShow} dimensionsImage={dimensionalImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} isEditOrder={isEditOrder} enableCrops={enableCrops} loading={false} showDecideLaterOverlay={t12} setSelectedPhoto={t13} dimensionShotUrls={dimensionShotUrls} currentDimensionShot={currentDimensionShotToShow} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} goToNextDimensionShot={goToNextDimensionShot} goToPreviousDimensionShot={goToPreviousDimensionShot} studioPhotos={studioPhotos} isConfigFlipped={isConfigFlipped} introVideoIds={introVideoIds} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} productName={productName} cylindoFeatures={cylindoFeatures} isCylindoAvailable={isCylindoAvailable} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} viewGalleryImageEvent={viewGalleryImageEvent} pdpIsModularBYOProduct={pdpIsModularBYOProduct} mode={mode} mainPhotoLink={mainPhotoLink} campaign={campaign} displayOnlyConfigImages={t14} />;
    $[37] = campaign;
    $[38] = configurationPhotos;
    $[39] = currentDimensionShotToShow;
    $[40] = cylindoFeatures;
    $[41] = dimensionShotUrls;
    $[42] = dimensionalImage;
    $[43] = enableCrops;
    $[44] = goToNextDimensionShot;
    $[45] = goToPreviousDimensionShot;
    $[46] = hasMultipleDimensionShots;
    $[47] = introVideoIds;
    $[48] = isConfigFlipped;
    $[49] = isCylindoAvailable;
    $[50] = isCylindoConfigurationPhotos;
    $[51] = isEditOrder;
    $[52] = isVideoSelected;
    $[53] = mainPhotoLink;
    $[54] = mode;
    $[55] = pdpIsModularBYOProduct;
    $[56] = productName;
    $[57] = selectedDimensionShotIndex;
    $[58] = selectedPhotoToShow;
    $[59] = setIsVideoSelected;
    $[60] = shouldShowDimensionThumbnail;
    $[61] = studioPhotos;
    $[62] = t12;
    $[63] = t13;
    $[64] = t14;
    $[65] = viewGalleryImageEvent;
    $[66] = t15;
  } else {
    t15 = $[66];
  }
  let t16;
  if ($[67] !== t11 || $[68] !== t15) {
    t16 = <Prefetcher {...t11}>{t15}</Prefetcher>;
    $[67] = t11;
    $[68] = t15;
    $[69] = t16;
  } else {
    t16 = $[69];
  }
  return t16;
};
PDPDesktopHeroGallery.propTypes = {
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  mainPhotoLink: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPDesktopHeroGallery;